import { HTTPClient } from "../common/HTTPClient";

export interface ItemSearchRequestParams {
  shopId: number;
  myCloudSku: string;
}

export class ItemClient {
  constructor(private httpClient: HTTPClient) {}

  public async postSearch(params: ItemSearchRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/items/search",
      method: "POST",
      data: params
    });

    return data;
  }

  public async getItemByCategoryId(categoryId: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/items/${categoryId}`,
      method: "GET"
    });

    return data;
  }
}
